var arrayLikeToArray = require("./arrayLikeToArray");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amcharts/amcharts4/node_modules/@babel/runtime/helpers/arrayWithoutHoles.js
// module id = 3064
// module chunks = 1